var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
import API from '../util/ApiUtil';
export class BannerStore {
    constructor(rootStore) {
        Object.defineProperty(this, "cloudinaryUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '//res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,'
        });
        Object.defineProperty(this, "bannersMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        this.translateStore = rootStore.translateStore;
    }
    async fetchBanner(slug) {
        const lang = this.translateStore.currentLanguage;
        return API.get(`/api/banner/${slug}/${lang}`)
            .then((response) => {
            if (response.data.directMarketingAllowed) {
                this.bannersMap.set(slug, response.data.banner);
            }
        })
            .catch((e) => {
            console.error(e);
        });
    }
    getBanner(slug) {
        return this.bannersMap.get(slug);
    }
    getDesktopSrcSetForBanner(slug) {
        const bannerDesktopUrl = this.bannersMap.get(slug).desktopUrl;
        return `${this.cloudinaryUrl}w_1024/${bannerDesktopUrl} 1024w, ${this.cloudinaryUrl}w_2048/${bannerDesktopUrl} 2048w`;
    }
    getMobileSrcSetForBanner(slug) {
        const bannerMobileUrl = this.bannersMap.get(slug).mobileUrl;
        return `${this.cloudinaryUrl}w_1960/${bannerMobileUrl} 1960w, ${this.cloudinaryUrl}w_1180/${bannerMobileUrl} 1180w`;
    }
}
__decorate([
    observable
], BannerStore.prototype, "bannersMap", void 0);
__decorate([
    action.bound
], BannerStore.prototype, "fetchBanner", null);
export default BannerStore;
